import React from 'react'

const VenueFeatureIcon = ({icon}) => (
    <svg className="venue-feature_icon" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" dangerouslySetInnerHTML={
        {__html:
            `<use xlink:href="#${icon}"></use>`
        }
    }
    />
)
export default VenueFeatureIcon;



// WEBPACK FOOTER //
// ./src/components/VenueFeatureIcon/index.js